/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { useState, useEffect } from "react";
import Select from "react-select";
import { SearchBox } from "@fluentui/react";

const square = css`
    margin: 25px;
    height: 120px !important;
    width: 100px !important;
`;

const iconName = css`
    font-size: 16px;
    width: 100px;
`;

const iconStyle = css`
    font-size: 2em;
`;

const innerAddon = css`
    width: 250px;
`;

const IconViewerContainer = ({ iconsAll, categories }) => {
    const [selectedCat, setSelectedCat] = useState(null);
    const [search, setSearch] = useState("");
    const [icons, setIcons] = useState([]);
    const iconCategoriesList = categories?.map(cat => ({ value: cat.key, label: cat.value }));

    useEffect(() => {
        if (iconsAll) {
            const mappedIcons = iconsAll.slice(29);
            setIcons(mappedIcons);
        }
    }, [iconsAll]);

    const handleCategoryChange = (selectedOption) => {
        setSelectedCat(selectedOption);
    };

    const handleSearchChange = (event) => {
        if (!event) return setSearch("");
        setSearch(event.target.value);
    };

    const filteredIcons = icons.filter((icon) =>
        (!selectedCat || selectedCat.value === "" || icon.category === selectedCat.value) &&
        icon.name?.toLowerCase().startsWith(search?.toLowerCase())
    );

    return (
        <div className="container">
            <h1>Search available iGrad/Enrich icons</h1>
            <div className="row">
                <div className="col-lg-6">
                    <label className="control-label" style={{ marginBottom: "10px" }}>Filter icons by category</label>
                    <div>
                        <Select
                            options={iconCategoriesList}
                            value={selectedCat}
                            onChange={handleCategoryChange}
                            placeholder="Select a Category"
                            isClearable
                            styles={{ container: (base) => ({ ...base, width: "300px", display: "inline-block" }) }}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <label className="control-label" style={{ marginBottom: "10px" }}>Search an icon by name</label>
                    <div css={innerAddon}>
                         <SearchBox
                            onChange={handleSearchChange}
                            placeholder="Search"
                            iconProps={{ iconName: 'Search' }}
                            value={search}
                        />
                    </div>
                </div>
            </div>
            <hr />
            <div className="row">
                {filteredIcons.map((icon, index) => (
                    <div className="col-sm-2" key={index} css={square}>
                        <div>
                            <i className={`${icon.slug}`} css={iconStyle}></i>
                            <div css={iconName}>{icon.name}</div>
                        </div>
                        <button className="btn btn-link" style={{ fontSize: "11px", padding: "0px" }} onClick={() => navigator.clipboard.writeText(icon.slug)}>
                            Copy Class
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default IconViewerContainer;
